import React, { useEffect, useState } from "react";
import AgentsModule from "../../components/ui/support_admin/agents.tsx";
import CustomersModule from "../../components/ui/support_admin/customers.tsx";
import TelefonSMSModule from "../../components/ui/support_admin/telephonesms.tsx";
import CustomerDetailModule from "../../components/ui/support_admin/customerdetail.tsx";
import AdministerVoipModule from "../../components/ui/support_admin/administervoip.tsx";
import AgentDetailModule from "../../components/ui/support_admin/agentdetail.tsx";
import SkillsModule from "../../components/ui/support_admin/skills.tsx";
import ReportsModule from "../../components/ui/support_admin/reports.tsx";
import CmsAndInnholdModule from "../../components/ui/support_admin/cms.tsx";
import { useNavigate } from "react-router-dom";
import HeaderModule from "../../components/ui/support_admin/header.tsx";
import SidebarModule from "../../components/ui/support_admin/sidebar.tsx";
import EnlargedCardModalModule from "../../components/ui/support_admin/enlargecardmodal.tsx";
import DashboardModule from "../../components/ui/support_admin/dashboard.tsx";
import axios from "axios";
import SocialMediaModule from "../../components/ui/support_admin/socialmedia.tsx";
import KursAndEventerModule from "../../components/ui/support_admin/kursandeventer.tsx";
import { RootState } from "../../state/store.ts";
import { useSelector } from "react-redux";

type ClientDashboardProps = {
    currentUser: any,
    onLogout: () => void,
    baseUrl: string,
    onLoginClick: () => void,
    onLoginSuccess: () => void,
}
export default function ClientDashboard({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess }: ClientDashboardProps) {
    const [enlargedCard, setEnlargedCard] = useState<null | {
        label: string;
        value: string;
        trend: string;
    }>(null);
    const [mobileMenu, setMobileMenu] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {
        // If there's no current user, or the user's role is neither 'support' nor 'client', redirect home
        if (!currentUser || (currentUser.role !== 'support' && currentUser.role !== 'client')) {
            navigate('/'); // Redirect to home if not logged in or not a support or client
        }
    }, [currentUser, navigate]);

    const [tab, setTab] = useState(localStorage.getItem('supportCurrentTab') || "Dashboard");

    useEffect(() => {
        localStorage.setItem('supportCurrentTab', tab);
    },[tab])

    const [profile, setProfile] = useState<any>(null);
    const client = useSelector((state: RootState) => state.client.client);

    useEffect(() => {

        axios.get(`${baseUrl}/getSupportByUid`, { params: { token: currentUser.token } })
            .then((response) => {

                if (response.data.status === "OK") {
                    setProfile(response.data.data);
                } else {
                    setProfile(null);
                }
            })
            .catch((err) => {
                console.error(err)
            });
    }, [currentUser?.token, baseUrl]);

    const [selectedEvent, setSelectedEvent] = useState<any>(null);



    return (
        <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col md:flex-row">
            {/* SIDEBAR */}
            <SidebarModule tab={tab} setTab={setTab} mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} profile={profile} baseUrl={baseUrl} onLogout={onLogout} />

            {/* MAIN */}
            <div className="flex-1 flex flex-col min-w-0">

                <HeaderModule tab={tab} setTab={setTab} currentUser={currentUser} onLogout={onLogout} profile={profile} baseUrl={baseUrl} />
                <main className="flex-1 overflow-y-auto p-8 space-y-8">
                    {tab === "Dashboard" && (
                        <DashboardModule enlargedCard={enlargedCard} setEnlargedCard={setEnlargedCard} baseUrl={baseUrl} currentUser={currentUser} setTab={setTab} />
                    )}

                    {tab === "Agenter" && (
                        <AgentsModule tab={tab} setTab={setTab} baseUrl={baseUrl} currentUser={currentUser} client={client} />
                    )}

                    {tab === "Agent detail" && (
                        <AgentDetailModule tab={tab} setTab={setTab} baseUrl={baseUrl} currentUser={currentUser} client={client} />
                    )}

                    {tab === "Kunder" && (
                        <CustomersModule tab={tab} setTab={setTab} />
                    )}

                    {tab === "Nummer & telefoni" && (
                        <TelefonSMSModule tab={tab} setTab={setTab} />
                    )}

                    {tab === "Administer voip" && (
                        <AdministerVoipModule />
                    )}

                    {tab === "Customer detail" && (
                        <CustomerDetailModule tab={tab} setTab={setTab} />
                    )}

                    {tab === "Ferdigheter" && (
                        <SkillsModule setTab={setTab} />
                    )}

                    {tab === "Rapporter & økonomi" && (
                        <ReportsModule />
                    )}

                    {tab === "CMS & innhold" && (
                        <CmsAndInnholdModule />
                    )}

                    {tab === "Kurs & eventer" && (
                        <KursAndEventerModule currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl} onLoginClick={onLoginClick} onLoginSuccess={onLoginSuccess} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} setTab={setTab} />
                    )}

                    {tab === "Sosiale medier" && (
                        <SocialMediaModule />
                    )}

                </main>
            </div>

            {/* ENLARGED CARD MODAL */}
            {enlargedCard && (
                <EnlargedCardModalModule enlargedCard={enlargedCard} setEnlargedCard={setEnlargedCard} />
            )}
        </div>
    );
}
